<template>
  <div class="">
    <ExamExamUpload modalType="exam" />
  </div>
</template>

<script>
import ExamExamUpload from "./ModalExamUpload.vue";
export default {
  name: "ExamManagementUpload",
  components: { ExamExamUpload },
};
</script>

<style>
</style>
